module.exports = JSON.parse('{"languageSwitcher":{"label":"ენა"},"close":"დახურვა","pageTitle":"ახალი წელი 2027 — არაფერი ზედმეტი! | NL International"}')